import dynamic from 'next/dynamic';

import ApplyBlindModalLink from '../../assets/apply_blind_modal_link.json';
import ApplyBlindModalMail from '../../assets/apply_blind_modal_mail.json';

const Lottie = dynamic(() => import('react-lottie'), { ssr: false });

export const BaeminRequestCards = ({ platformName }: { platformName: string }) => (
  <>
    <div className="border border-cds-coolgray-15 rounded-2xl py-5 px-3 text-center mb-3.5">
      <Lottie
        options={{ loop: true, autoplay: true, animationData: ApplyBlindModalMail }}
        width={81}
        height={77}
      />
      <p className="text-cds-coolgray-85 font-normal leading-[150%] tracking-[-0.176px]">
        최종 신청서 작성 링크는
      </p>
      <p>
        <span className="text-cds-orange-55 font-semibold leading-[150%] tracking-[-0.176px]">
          {platformName}에 등록된 휴대폰 번호
        </span>
        <span className="text-cds-coolgray-85 font-normal leading-[150%] tracking-[-0.176px]">
          로 전송돼요
        </span>
      </p>
    </div>
    <div className="border border-cds-coolgray-15 rounded-2xl py-5 px-3 text-center">
      <div className="flex justify-center mb-3">
        <Lottie
          options={{ loop: true, autoplay: true, animationData: ApplyBlindModalLink }}
          width={81}
          height={77}
        />
      </div>
      <p className="text-cds-coolgray-85 font-normal leading-[150%] tracking-[-0.176px]">
        받은 최종 신청서 링크에서
      </p>
      <p>
        <span className="text-cds-orange-55 font-semibold leading-[150%] tracking-[-0.176px]">
          신청 사유를 작성
        </span>
        <span className="text-cds-coolgray-85 font-normal leading-[150%] tracking-[-0.176px]">
          하고 접수를 완료해요
        </span>
      </p>
    </div>
  </>
);
